// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edituserrolepermissiondialog_featuredItem__24DAs {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
}

.edituserrolepermissiondialog_featuredTable__4z8fL {
    flex: 1 1;
    margin: 0px 20px;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
}

.edituserrolepermissiondialog_featuredTitleHeader__Mwe55 {
    font-size: 16px;
    font-weight: bold;
    color: #133454;
}

.edituserrolepermissiondialog_featuredText__6mQTd {
    color: var(--hsrcDarkBlue);
    font-size: 14px;
    font-weight: normal;
}

.edituserrolepermissiondialog_dialogInputs__eo6ZB {
    width: 100%;
}

.edituserrolepermissiondialog_table_header_cell__HNmzt {
    background-color: var(--hsrcMidGreen);
}`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/components/PermissionsManagement/EditUserRolePermissionDialog/edituserrolepermissiondialog.module.css"],"names":[],"mappings":"AAAA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,kDAAkD;AACtD;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC","sourcesContent":[".featuredItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.featuredTable {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.featuredTitleHeader {\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    color: #133454;\r\n}\r\n\r\n.featuredText {\r\n    color: var(--hsrcDarkBlue);\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n}\r\n\r\n.dialogInputs {\r\n    width: 100%;\r\n}\r\n\r\n.table_header_cell {\r\n    background-color: var(--hsrcMidGreen);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featuredItem": `edituserrolepermissiondialog_featuredItem__24DAs`,
	"featuredTable": `edituserrolepermissiondialog_featuredTable__4z8fL`,
	"featuredTitleHeader": `edituserrolepermissiondialog_featuredTitleHeader__Mwe55`,
	"featuredText": `edituserrolepermissiondialog_featuredText__6mQTd`,
	"dialogInputs": `edituserrolepermissiondialog_dialogInputs__eo6ZB`,
	"table_header_cell": `edituserrolepermissiondialog_table_header_cell__HNmzt`
};
export default ___CSS_LOADER_EXPORT___;
